<template>
  <div class="contentBox">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item v-if="abnormal == 'Purchase'">
        <el-radio-group class="chenckBox" v-model="radio">
          <el-radio :label="item.value" v-for="item in abnormals" :key="item.value">{{ item.title }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="abnormal != 'Purchase'">
        <div class="chenckBox" v-for="item in abnormals" :key="item.value">
          <el-checkbox v-model="item.checked">{{ item.title }}</el-checkbox>
        </div>
      </el-form-item>
      <el-form-item label="">
        <!-- <el-input maxlength='450' v-model="expressPhone" placeholder="采购手机号" /> -->
      </el-form-item>
      <el-form-item label="备注:" :required="abnormals?.filter(v => v.checked)?.map(v => v.value)?.includes('317') || abnormals?.filter(v => v.checked)?.map(v => v.value)?.includes('315')">
        <el-input maxlength='450' type="textarea" :autosize="{ minRows: 5, maxRows: 4 }" v-model="textarea"
          placeholder="备注" />
      </el-form-item>
      <el-form-item label="图片">
        <div class="imgBlock">
          <div class="preview__li" v-for="(item, index) in images" :key="index">
            <!-- <ImgPreviews :images="[item.imgUrl]" width="100" height="100" /> -->
            <el-tooltip class="item" effect="light" placement="top" :disabled="(!record.imgTagFlag && !record.imgDefectiveTagFlag) || disabledChoose">
              <div slot="content">
                <div v-if="record.imgTagFlag">
                  <el-checkbox v-model="item.outside" label="表面" border
                    @change="e => changeCheckbox(e, item, 'outside')"></el-checkbox>
                  <el-checkbox v-model="item.inside" label="内里" border
                    @change="e => changeCheckbox(e, item, 'inside')"></el-checkbox>
                </div>
                <div style="margin-top: 6px;" v-if="record.imgDefectiveTagFlag">
                  <el-checkbox v-model="item.normal" label="正品" border
                    @change="e => changeCheckbox(e, item, 'normal')"></el-checkbox>
                  <el-checkbox v-model="item.defective" label="次品" border
                    @change="e => changeCheckbox(e, item, 'defective')"></el-checkbox>
                </div>
              </div>
              <el-image :src="item.imgUrl" :style="{ width: '100px', height: '100px' }"
                :preview-src-list="[item.imgUrl]" alt="图片" class="previewsImage-tag">
              </el-image>
            </el-tooltip>
            <i class="el-icon-error" @click="delImg(item, index)"></i>
          </div>
          <el-upload class="uploader" :action="actionUrl" :on-change="uploadChange" :before-upload="beforeUpload"
            :data="uploadData" :http-request="uploadToOSS" :file-list="fileList" :show-file-list="false"
            v-if="images.length < 5">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div style="color:red;font-size: 12px;" v-if="record.imgTagFlag">
          注意：入库商品中包含有沼田客户货物，请将异常商品图片标明”表面“或”内里“
        </div>
      </el-form-item>
      <el-form-item label="移动端上传扫码:">
        <canvas :id="canvasId" width="100" height="100" />
      </el-form-item>
      <el-form-item label="">
        <ul>
          <li>
            <el-input maxlength='450' v-model="abnormalAmount" style="width:100px"></el-input>
          </li>
          <li>
            <el-button type="primary" @click="submit">
              {{ btnTitle }}
            </el-button>
          </li>
          <li>
            <el-button :loading="loading" @click="getImages">
              获取图片
            </el-button>
          </li>
        </ul>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import IptNumber from "@/components/IptNumber";
import ImgPreviews from "@/components/ImgPreviews";

const addFlag = function (list) {
  return list.map((item, index) => {
    return { ...item, checked: index == 0 ? true : false };
  });
};
import QRCode from "qrcode";
import axios from "axios";
import { Descriptions } from "ant-design-vue";
import { Validator } from "@/utils/verification";
import { getApplyCode, imgByCode, OSSsign, imageToOss, imgSave, deleteImageApi } from "@/apis/inHouse";
export default {
  name: "Content",
  props: {
    btnTitle: {
      type: String,
      required: true, // 必填
    },
    abnormalType: {
      type: Array,
      required: true, // 必填
    },
    abnormal: {
      type: String,
      required: true,
      default() {
        return "Purchase";
      },
    },
    disabledChoose: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    [Descriptions.name]: Descriptions,
    [Descriptions.Item.name]: Descriptions.Item,
    ImgPreviews,
    IptNumber,
  },
  data() {
    return {
      canvasId: Math.random().toFixed(8),
      qrCode: "code",
      abnormalAmount: 0,
      abnormals: addFlag(JSON.parse(JSON.stringify(this.abnormalType))),
      textarea: "",
      loading: false,
      images: [],
      expressPhone: "",
      radio: '',
      fileList: [],
      uploadData: { path: "transfer/" },
      actionUrl: "http://192.168.103.145/customer/oss/putOSS"
    };
  },
  watch: {
    qrCode: {
      immediate: true,
      handler: function (newVal, oldVal) {
        console.log(newVal)
        if (!newVal) {
          return
        }
        console.log(newVal)
        this.$nextTick((_) => {
          let canvas = document.getElementById(this.canvasId);
          QRCode.toCanvas(canvas, newVal, function (error) {
            if (error) console.error(error);
          });
        });
      },
      immediate: true,
      keep: true,
    },
    abnormals: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.radio = newVal[0].value
      },
      immediate: true,
      keep: true,
    },
  },
  mounted() {
    this.getCode();
  },
  computed: {},
  methods: {
    changeCheckbox(val, item, k) {
      if (val) {
        if (k === 'inside') {
          item.inside = true
          item.outside = false
        }
        if (k === 'outside') {
          item.inside = false
          item.outside = true
        }
        if (k === 'normal') {
          item.normal = true
          item.defective = false
        }
        if (k === 'defective') {
          item.normal = false
          item.defective = true
        }
      } else {
        item[k] = false
      }

      imgSave({
        imgDTOList: this.images.map(v => {
          const tagList = []
          const keys = ['outside', 'inside', 'normal', 'defective']
          keys.forEach((keyItem) => {
            if (v[keyItem]) {
              tagList.push(keyItem)
            }
          })
          return ({
            imgUrl: v.imgUrl,
            tagList: tagList
          })
        }),
        operationType: 1,
        picRelation: this.qrCode,
      })
    },
    getImages: function () {
      imgByCode({ picRelation: this.qrCode }).then(({ code, data }) => {
        // console.log(code, data);
        if (code === 0) {
          this.images = data.map(v => ({
            ...v,
            outside: v.tagList?.includes('outside'),
            inside: v.tagList?.includes('inside'),
            normal: v.tagList?.includes('normal'),
            defective: v.tagList?.includes('defective')
          }));
          // this.$message.success("成功");
        }
      });
    },
    submit: function () {
      // let validator = new Validator();
      // validator.add_batch(this.expressPhone, [
      //   {
      //     strategy: "isNoneEmpty",
      //     errorMsg: "请填写手机号",
      //   },
      //   {
      //     strategy: "isMobile",
      //     errorMsg: "请填写正确的手机号",
      //   },
      // ]);
      // let error = validator.start();
      // if (error) {
      //   this.$message.error(error);
      //   return;
      // }
      const { abnormalAmount, qrCode, textarea, abnormals } = this;
      if((this.abnormals?.filter(v => v.checked)?.map(v => v.value)?.includes('317') || this.abnormals?.filter(v => v.checked)?.map(v => v.value)?.includes('315')) && !textarea) {
        this.$message.warning('请填写备注')
        return
      }
      const _abnormals = abnormals
        .filter((item) => item.checked)
        .map((item) => item.value);
      this.$emit("submitAbnormal", {
        abnormalAmount,
        qrCode,
        textarea,
        abnormal: _abnormals,
      });
      this.getCode()
    },
    getCode() {
      let params = {
        num: 1,
      };
      getApplyCode(params).then(({ code, data }) => {
        if (code === 0) {
          this.qrCode = data[0];
          this.getImages()
        }
      });
    },
    beforeUpload(res) {
    },
    uploadChange(res) {
    },
    uploadToOSS(res) {
      // return false
      let name = String(Date.parse(new Date()) + res.file.name);
      let key = "transfer/" + name;
      OSSsign({ path: "transfer/" }).then(({ code, data }) => {
        let forms = new FormData();
        forms.append("name", name);
        forms.append("key", key);
        forms.append("OSSAccessKeyId", data.accessId);
        forms.append("policy", data.policy);
        forms.append("signature", data.signature);
        forms.append("success_action_status", 200);
        forms.append("file", res.file);
        // imageToOss(data.host, forms);
        let host = data.host
        if (location.href.indexOf('https') > -1 && host.indexOf('https') === -1) {
          host = host.replace('http', 'https')
        }
        axios({
          method: "post",
          url: host,
          data: forms,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then((res) => {
          if (res.status == 200) {
            this.saveImg(`${data.customDomain}/${key}`)
          }
        });
      });
    },
    saveImg(url) {
      let parmas = {
        picRelation: this.qrCode,
        imgUrls: [url]
      }
      imgSave(parmas).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success('添加成功')
          this.getImages()
        }
      })
    },
    //删除图片
    delImg(record, index) {
      deleteImageApi({
        id: record.id,
      }).then((res) => {
        this.$message.success('删除成功！')
        this.images.splice(index, 1);
      });
    },
  },
};
</script>

<style scoped>
.abnormal__div {
  display: grid;
  grid-template-columns: 120px auto 200px 140px;
  grid-column-gap: 20px;
}

.abnormal__div--qrCode {
  width: 180px;
  height: 150px;
  padding-right: 30px;
  position: relative;
  top: 0;
  left: 0;
}

.abnormal__div--qrCode>span {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  width: 30px;
  height: 150px;
  text-align: center;
  writing-mode: vertical-lr;
}

.abnormal__div--qrCode span {
  font-weight: 600;
}

.abnormal__div--submit {
  padding: 20px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
}

.checkbox__div {
  height: 140px;
  background: #f8f8f9;
  border-radius: 10px;
  grid-column-start: 1;
  grid-column-end: 3;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  padding: 20px 400px 20px 20px;
  position: relative;
  top: 0;
  left: 0;
  /*grid-row-start: 1;*/
  /*grid-row-end: 2;*/
}

.checkbox__div--textarea {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 390px;
  height: 120px;
}

.checkbox__div--item {
  margin-right: 20px;
  margin-bottom: 14px;
  font-weight: 600 !important;
}

.imgBlock {
  display: flex;
  width: 340px;
  flex-wrap: wrap;
}

.preview__ul {
  display: flex;
  /* grid-column-start: 1;
  grid-column-end: 5;
  grid-row-start: 2;
  grid-row-end: 3; */
  justify-content: flex-end;
  align-items: center;
  margin: 0;
  box-sizing: border-box;
  padding: 0 20px;
}

.preview__li {
  width: 100px;
  height: 100px;
  background: white;
  margin: 5px;
  position: relative;
}

.preview__li .el-icon-error {
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 20px;
  cursor: pointer;
}

::v-deep .el-textarea textarea {
  height: 120px;
}

.contentBox {
  display: flex;
  flex-direction: column;
}

.chenckBox {
  width: 200px;
}

.phoneBox {
  width: 240px;
}

.uploader {
  border: 1px solid #eee;
  height: 100px;
  width: 100px;
  margin: 5px;
}

.uploader i {
  height: 100px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
